import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1300Model } from '../kymw1300.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';

/**
 * 商品企画マスタ画面　企画ロック取得するサービス
 *
 * @export RegistLockInfoCatalogService
 * @class RegistLockInfoCatalogService
 * @extends {PlessJsonResponderSub<any>}
 */
@Injectable()
export class RegistLockInfoCatalogService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1300Model}
   * @memberof RegistLockInfoCatalogService
   */
  private model: KYMW1300Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {Object}
   * @memberof RegistLockInfoCatalogService
   */
  private vo: {
    orderCode: '',
    mediumType: '',
  };

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof RegistLockInfoCatalogService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistLockInfoCatalogService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        RegistLockInfoCatalog: {
          condition: {
            OrderCode: this.vo.orderCode,
            MediumType: this.vo.mediumType
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof RegistLockInfoCatalogService
   */
  execute(model: any, vo: any, successFunc: Function): void {
    this.model = <KYMW1300Model> model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('registLockInfoCatalog', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistLockInfoCatalogService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }

}
